import React from 'react';

interface SmartphoneFrameProps {
  children: React.ReactNode;
  active?: boolean;
}

export const SmartphoneFrame: React.FC<SmartphoneFrameProps> = ({ children, active = true }) => {
  return (
    <div className={active ? 'flex items-center justify-center h-full py-6 @container-[size]' : 'flex-1 flex flex-col'}>
      {/* mobile-ui.4.A: width is the ONLY specified axis (height derives via aspect-ratio),
          computed against the size container above — min(cap 390px, container width,
          width that makes height fill the container). Specifying both axes (old w-full
          h-full) made CSS ignore aspect-ratio; max-width clamps over h-full distort. */}
      <div
        className={active
          ? 'relative w-[min(390px,100cqw,calc(100cqh*390/844))] aspect-390/844 bg-black rounded-[50px] border-[6px] border-neutral-700 shadow-2xl flex flex-col overflow-hidden'
          : 'flex-1 flex flex-col'
        }
      >

        {/* Status bar (notch area) — hidden when inactive */}
        <div className={`relative h-12 bg-black flex items-end justify-center pb-1 z-10 shrink-0 ${active ? '' : 'hidden'}`}>
          {/* Dynamic Island */}
          <div className="w-[120px] h-[34px] bg-black rounded-full absolute top-1" />
          {/* Time + battery */}
          <div className="flex items-center justify-between w-full px-8 text-white text-xs font-medium">
            <span>9:41</span>
            <div className="flex items-center gap-1">
              <div className="w-4 h-2 border border-white rounded-sm relative">
                <div className="absolute inset-[1px] right-[2px] bg-white rounded-[1px]" />
              </div>
            </div>
          </div>
        </div>

        {/* Viewport — scrollable content area */}
        <div className={active ? 'flex-1 overflow-y-auto overflow-x-hidden' : 'flex-1'}>
          {children}
        </div>

        {/* Home indicator — hidden when inactive */}
        <div className={`h-8 bg-black flex items-center justify-center shrink-0 ${active ? '' : 'hidden'}`}>
          <div className="w-32 h-1 bg-neutral-600 rounded-full" />
        </div>
      </div>
    </div>
  );
};
